import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminsuperbranch',
  templateUrl: './adminsuperbranch.component.html',
  styleUrls: ['./adminsuperbranch.component.css']
})
export class AdminsuperbranchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
